import { FunctionComponent, MouseEventHandler, useEffect } from 'react'
import ReactDOM from 'react-dom'
import { useLocation } from 'react-router-dom'

import { RenderIf } from '../RenderIf'
import { useModalContext } from './contexts/ModalContext'
import { useStyles } from '@/components/Modal/styles'
import { ModalProps } from './types'

const Modal: FunctionComponent<ModalProps> = props => {
  const { children, id, onDismiss, styles } = props
  const { open, settings, closeModal } = useModalContext()
  const defaultStyles = useStyles({ settings })

  const handleOverlayClick: MouseEventHandler = event => {
    const target = event.target as HTMLDivElement

    if (
      typeof target.className === 'string' &&
      target.className.includes('modal-overlay') &&
      !settings?.persistent
    ) {
      closeModal()
      onDismiss && onDismiss()
    }
  }

  const handleModalDismiss = () => {
    closeModal()
    onDismiss && onDismiss()
  }

  const location = useLocation()

  useEffect(() => {
    closeModal()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [location])

  if (open !== id) return null

  return ReactDOM.createPortal(
    <div
      css={defaultStyles.modalGeneral}
      className="modal-overlay"
      onClick={handleOverlayClick}
    >
      <div
        css={[defaultStyles.modalContent, styles?.container]}
        className="safari-only"
      >
        <div
          css={defaultStyles.modalHeader}
          className={settings?.title ? 'withTitle' : ''}
        >
          <RenderIf condition={!!settings?.title}>
            <h4>{settings?.title}</h4>
          </RenderIf>

          <RenderIf condition={!settings?.persistent}>
            <button onClick={handleModalDismiss}>&times;</button>
          </RenderIf>
        </div>

        <div className="modal-content" css={styles?.content}>
          {children}
        </div>
      </div>
    </div>,
    document.getElementById('modal-root'),
  )
}

export default Modal
